import { render, staticRenderFns } from "./ChatMessageCard.vue?vue&type=template&id=1060fa26&"
import script from "./ChatMessageCard.vue?vue&type=script&lang=ts&"
export * from "./ChatMessageCard.vue?vue&type=script&lang=ts&"
import style0 from "./ChatMessageCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports